<template>
  <div class="w-100">
    <div class="ga-container pb-4 z-index-1038">
      <div
        class="rounded-6 bg-white border-form box-shadow-light-aff overflow-hidden">
        <p
          class="mb-0 mx-3 body-2-2 text-black text-12"
          style="padding-top: 12px">
          {{ $t('hotel.tap-to-see-detail') }}
        </p>

        <!-- ROOM -->
        <div
          class="row no-gutters pt-3 mx-3"
          v-for="room_rate in getBeCart().room_rate_details">
          <div class="col-3">
            <img
              @click="detail(room_rate)"
              :src="room_rate.room_rate.room_type.image[0].image_url"
              class="img-fit w-100 rounded-3"
              style="height: 65px" />
          </div>
          <div class="col-9">
            <div class="ml-3">
              <div class="row no-gutters">
                <div class="col-10" @click="detail(room_rate)">
                  <p
                    class="w-100 mb-0 body-1-4 text-16 text-truncate cursor-pointer">
                    {{ room_rate.room_rate.name }}
                  </p>
                  <template v-if="isRoomDiscount(room_rate)">
                    <p
                      class="mb-0 body-3-3-1 text-line-through d-inline-block align-middle mr-2">
                      {{ $formatCurrency(calculateSubTotal(room_rate, false)) }}
                    </p>
                    <p
                      class="mb-0 body-2-2 text-12 font-semibold cursor-pointer d-inline-block align-middle">
                      {{ $formatCurrency(calculateSubTotal(room_rate)) }}
                    </p>
                  </template>
                  <p
                    v-else
                    class="w-100 mb-0 body-2-2 text-12 font-semibold cursor-pointer">
                    {{ $formatCurrency(calculateSubTotal(room_rate)) }}
                  </p>
                  <p
                    class="mb-0 body-2-2 text-12 font-semibold position-relative cursor-pointer">
                    <img
                      src="../../../../assets/img/icon/bed.png"
                      width="10"
                      class="d-inline-block mr-1 position-relative"
                      style="top: -1px" />
                    <span
                      >{{ room_rate.qty }}
                      {{
                        $t(
                          'hotel.unit-type.' +
                            room_rate.room_rate.room_type.type +
                            '.unit'
                        )
                      }}</span
                    >
                  </p>
                  <p
                    class="mb-0 body-2-2 text-12 font-semibold position-relative">
                    <img
                      src="../../../../assets/img/icon/users.png"
                      width="10"
                      class="d-inline-block mr-1 position-relative"
                      style="top: -1px" />
                    <span class="cursor-pointer">{{
                      filter_guest(room_rate.guest)
                    }}</span>
                  </p>
                </div>
                <div class="col-2 text-right no-ws pt-1">
                  <i
                    v-b-tooltip="`Adjust Pax`"
                    class="simple-icon-pencil font-weight-bold text-16 text-green cursor-pointer d-inline-block align-middle mr-2"
                    @click="onBack('adjustPax', room_rate)"></i>
                  <i
                    v-b-tooltip="`Remove Room`"
                    class="simple-icon-trash font-weight-bold text-16 text-danger cursor-pointer d-inline-block align-middle ml-1"
                    @click="removeRoomRate(room_rate)"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container mt-2 py-2 px-3">
          <div class="row">
            <div class="col-12">
              <div class="row no-gutters">
                <div class="col-6">
                  <p class="mb-1 body-2-2 text-12 font-semibold">
                    <img
                      src="../../../../assets/img/icon/calendar.png"
                      width="10"
                      class="d-inline-block mr-2 position-relative"
                      style="top: -2px" />{{ $t('hotel.date.check-in') }}
                  </p>
                  <p class="mb-1 body-2-2 text-12 font-semibold">
                    <img
                      src="../../../../assets/img/icon/calendar.png"
                      width="10"
                      class="d-inline-block mr-2 position-relative"
                      style="top: -2px" />{{ $t('hotel.date.check-out') }}
                  </p>
                </div>
                <div class="col-6 text-right">
                  <p class="mb-1 body-2-2 text-12 font-semibold">
                    {{ formatDate(getBeFilter().date.check_in) }}
                  </p>
                  <p class="mb-1 body-2-2 text-12 font-semibold">
                    {{ formatDate(getBeFilter().date.check_out) }}
                  </p>
                </div>
              </div>
            </div>
            <div v-if="isUnderSearchPax()" class="col-12 pb-2">
              <div
                class="w-100 p-3 text-center border mt-3"
                style="
                  background-color: rgb(255, 246, 243);
                  border-color: rgb(254, 207, 184) !important;
                ">
                <p class="mb-0 body-2-1">{{ isUnderSearchPax() }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- ADDITIONAL SERVICE -->
        <div
          class="border-t-form px-3 pt-3"
          v-if="total_additional_service > 0">
          <ProductCart page="CART-ADDITIONAL" :hide-remove="false" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import { formatCurrency, formatDate } from '@/utils/index.js';
import ProductCart from '../additionalService/ProductCart.vue';

export default {
  components: {
    ProductCart,
  },
  computed: {
    total_additional_service() {
      let total =
        this.getBeAddtServiceSubTotal() + this.$totalAddtServiceModule();
      return total;
    },
  },
  methods: {
    ...mapGetters([
      'getBeCart',
      'getBeFilter',
      'getCurrentLanguage',
      'isUnderSearchPax',
      'getBeAddtServiceSubTotal',
    ]),
    ...mapMutations(['beRemoveRoomRate', 'changeBeRoomAvbl']),
    formatDate(date) {
      return formatDate(date);
    },
    formatCurrency(value) {
      return formatCurrency(value);
    },
    calculateSubTotal(data, with_discount = true) {
      let total = 0;
      for (let i = 0; i < data.qty; i++) {
        for (let date of data.room_rate.dates) {
          let total_extra = {
            adult: data.guest[i].extra.adult * date.extra_guest.adult.amount,
            child: data.guest[i].extra.child * date.extra_guest.child.amount,
            infant: data.guest[i].extra.infant * date.extra_guest.infant.amount,
          };
          let total_extra_price =
            total_extra.adult + total_extra.child + total_extra.infant;
          let base_price = with_discount
            ? date.price + date.promotion_price
            : date.price;
          if (total_extra_price > 0) {
            total += base_price + total_extra_price;
          } else {
            total += base_price;
          }
        }
      }
      return total;
    },
    isRoomDiscount(data) {
      let total = 0;
      for (let date of data.room_rate.dates) {
        total += date.promotion_price;
      }
      return total < 0;
    },
    detail(data) {
      this.$emit('detail', data);
    },
    onBack(type, data) {
      this.$emit(type, data);
    },
    removeRoomRate(cart) {
      this.beRemoveRoomRate(cart.room_rate.id);
      let roomtype_params = {
        id: cart.room_rate.room_type.id,
        rr_id: cart.room_rate.id,
        qty: cart.qty,
        action: 'inc',
        is_virtual: cart.room_rate.room_type.is_virtual,
        availability_affected: cart.room_rate.room_type.availability_affected,
      };
      this.changeBeRoomAvbl(roomtype_params);
    },
    filter_guest(room_rate) {
      let total_guest = {
        adult: 0,
        child: 0,
        infant: 0,
        extra: 0,
      };
      room_rate.forEach((item) => {
        total_guest.adult += item.included.adult;
        total_guest.child += item.included.child;
        total_guest.infant += item.included.infant;
        total_guest.extra +=
          item.extra.adult + item.extra.child + item.extra.infant;
      });
      let container = [];
      if (total_guest.adult > 0) {
        container.push(
          total_guest.adult + ' ' + this.$t('hotel.adults.adults')
        );
      }
      if (total_guest.child > 0) {
        container.push(
          total_guest.child + ' ' + this.$t('hotel.children.children')
        );
      }
      if (total_guest.infant > 0) {
        container.push(
          total_guest.infant + ' ' + this.$t('hotel.infants.infants')
        );
      }
      if (total_guest.extra > 0) {
        container.push(
          `${total_guest.extra} ${this.$pluralWord(
            total_guest.extra,
            this.$t('hotel.extra-guest')
          )}`
        );
      }

      let display = '';
      for (let i = 0; i < container.length; i++) {
        if (i + 1 == container.length) {
          display += container[i];
        } else {
          display += container[i] + ', ';
        }
      }

      return display;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/hotel/be/mobile/cartRoomRateDetail.vue